/**
 * Created by jonas on 2020-05-26.
 */
import {GambleTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GambleTransitionController";
import {BookOfShadowsGameModuleConfig} from "../BookOfShadowsGameModuleConfig";
import {BookOfShadows} from "../BookOfShadows";

export class BookOfShadowsExitGambleTransition extends GambleTransitionController {

    constructor(fromMode: string, toMode: string) {
        super(fromMode, toMode);
    }

    protected cleanUpBeforeModeStart() {
        if (this._serverData.nextReelSetName === "FREESPIN_REELSET") {
            BookOfShadowsGameModuleConfig.inactiveRowController.updateVisibleRows();
            BookOfShadowsGameModuleConfig.gameTutorial.exitFS();
            BookOfShadowsGameModuleConfig.reelLockController.exitedFS();

            // #155
            BookOfShadows.setBoostedBet();

            // #286
            BookOfShadows.api.betHandler.cancelNextAutoBetAfterCollect();
        } else {
            BookOfShadowsGameModuleConfig.reelBackgroundView.resetAllSymsToNormal();
        }
    }
}